import type { AppointmentProvider } from '../../../react-query/useAppointments';
import { capitalize } from '../../../utils/string';

export const getProviderName = (provider?: AppointmentProvider) => {
  if (provider?.firstName && provider.lastName) {
    return `${capitalize(provider.firstName)} ${capitalize(provider.lastName)}`;
  }
  return provider?.firstName ?? provider?.lastName ?? 'Unknown';
};
